/**
 * ========================================
 * LA MAISON DES HOUSSES - SCRIPTS GLOBAUX
 * ========================================
 * Tous les scripts interactifs du site
 * Version 1.0 - Novembre 2025
 * ========================================
 */

document.addEventListener('DOMContentLoaded', function() {
    'use strict';
    
    console.log('🚀 Scripts La Maison des Housses chargés');
    
    // ========================================
    // FONCTION GÉNÉRIQUE POUR LES GUIDES D'ENTRETIEN
    // ========================================
    function initCareGuide(containerId) {
        const guideContainer = document.querySelector(`#${containerId}`);
        if (!guideContainer) return false;
        
        console.log(`✅ Guide trouvé: ${containerId}`);
        
        const materialCards = document.querySelectorAll(`#${containerId} .lmdh-material-card`);
        const materialSections = document.querySelectorAll(`#${containerId} .lmdh-material-section`);
        
        if (materialCards.length === 0 || materialSections.length === 0) {
            console.warn(`⚠️ Éléments manquants dans ${containerId}`);
            return false;
        }
        
        console.log(`📦 ${containerId}: ${materialCards.length} cartes, ${materialSections.length} sections`);
        
        function showMaterialSection(materialType) {
            // Masquer toutes les sections
            materialSections.forEach(section => {
                section.classList.remove('active');
                section.style.display = 'none';
            });
            
            // Retirer la classe active de toutes les cartes
            materialCards.forEach(card => {
                card.classList.remove('active');
            });
            
            // Afficher la section correspondante
            const targetSection = document.querySelector(`#${containerId} [data-section="${materialType}"]`);
            if (targetSection) {
                targetSection.classList.add('active');
                targetSection.style.display = 'block';
                
                setTimeout(() => {
                    targetSection.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'start' 
                    });
                }, 100);
            }
            
            // Activer la carte sélectionnée
            const activeCard = document.querySelector(`#${containerId} [data-material="${materialType}"]`);
            if (activeCard) {
                activeCard.classList.add('active');
            }
        }
        
        // Ajout des événements sur les cartes
        materialCards.forEach(card => {
            card.addEventListener('click', function() {
                const materialType = this.getAttribute('data-material');
                showMaterialSection(materialType);
            });
            
            card.setAttribute('tabindex', '0');
            card.addEventListener('keypress', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const materialType = this.getAttribute('data-material');
                    showMaterialSection(materialType);
                }
            });
        });
        
        return true;
    }
    
    // ========================================
    // INITIALISATION AUTOMATIQUE DES GUIDES
    // ========================================
    const guidesInitialized = {
        'collection': initCareGuide('lmdh-care-guide-collection'),
        'easydraps': initCareGuide('lmdh-care-guide-easydraps'),
        'easycovers': initCareGuide('lmdh-care-guide-easycovers'),
        'chaises': initCareGuide('lmdh-care-guide-chaises')
    };
    
    console.log('📊 Résumé initialisation:', guidesInitialized);
    
    // ========================================
    // FUTURS SCRIPTS ICI
    // ========================================
    
    // Exemple : Script pour slider produits
    // initProductSlider();
    
    // Exemple : Script pour popup promo
    // initPromoPopup();
    
    console.log('✅ Tous les scripts La Maison des Housses sont prêts');
});